export type HostedCreditsMode = 'login' | 'buy' | null;

const LOW_CREDITS = 3;

export function hostedCreditsMode(opts: {
  chatHosted: boolean;
  settingsHosted: boolean;
  loggedIn: boolean;
  creditBalance: number | null;
  hostingActive?: boolean;
}): HostedCreditsMode {
  if (!opts.chatHosted && !opts.settingsHosted) return null;
  if (!opts.loggedIn) return 'login';
  if (opts.hostingActive) return null;
  if (opts.creditBalance === null) return null;
  if (opts.creditBalance <= LOW_CREDITS) return 'buy';
  return null;
}
